import { IANAToWindows } from '@/contants/date';

import { truncateTimeZoneDate } from './dates';
import { valueToNull, valueToNumber, valueToString } from './format';

export const parseCreateSpotQuoteDataFromFormData = (data) => {
  const trailerKeyValue = data?.trailerKey;

  return {
    ami: valueToString(data?.ami),
    bidExpirationDate: truncateTimeZoneDate(data?.bidExpirationDate),
    bidExpirationOffsetHours: data.bidExpirationOffsetHours,
    bidExpirationTimeZoneInfo: IANAToWindows(data.bidExpirationTimeZoneInfo) || data.bidExpirationTimeZoneInfo,
    cargoType: Array.isArray(data.cargoType) ? data.cargoType.join(', ') : data.cargoType,
    costCenter: valueToString(data?.costCenter),
    currencyCode: valueToString(data?.currencyCode),
    deliveryDate: truncateTimeZoneDate(data?.expDeliveryDate?.set({ hour: 12, minute: 0, second: 0 })),
    distance: valueToNull(valueToNumber(data?.distance)),
    incotermnamedPlace: valueToString(data?.incotermnamedPlace),
    incoterms: valueToString(data?.incoterms),
    po: valueToString(data?.po),
    psl: valueToString(data?.psl),
    quoteDetails: data?.products?.map((row) => ({
      class: valueToString(row?.class),
      cube: valueToNumber(row?.cube),
      dimUom: valueToString(row?.dimUom),
      harmonizedCode1: valueToString(row?.harmonizedCode1),
      harmonizedCode2: valueToString(row?.harmonizedCode2),
      hazardousClass: valueToString(row?.hazardousClass),
      height: valueToNumber(row?.height),
      length: valueToNumber(row?.length),
      productCode: valueToString(row?.productCode),
      productDescription: valueToString(row?.productDescription),
      quantity: valueToNumber(row?.quantity),
      weight: valueToNumber(row?.weight),
      weightUom: valueToString(row?.weightUom),
      width: valueToNumber(row?.width),
    })),
    quoteKey: data?.quoteKey,
    quoteNo: valueToString(data?.quoteNo),
    quoteNotes: valueToString(data?.quoteNotes),
    quoteTerms: valueToString(data?.quoteTerms),
    quoteTitle: valueToString(data?.quoteTitle),
    shipDate: truncateTimeZoneDate(data?.expShipDate?.set({ hour: 12, minute: 0, second: 0 })),
    shipment: valueToString(data?.shipment),
    status: valueToString(data?.status),
    totalCube: data?.totalCube,
    totalUnits: data?.totalUnits,
    totalWeight: data?.totalWeight,
    trailerKey: trailerKeyValue != null && trailerKeyValue !== '' ? valueToNumber(trailerKeyValue) : null,
    transportationDetails: data?.ports?.map((row) => ({
      addr2: valueToString(row?.addr2),
      address: valueToString(row?.addr1),
      companyName: valueToString(row?.companyName),
      countryCode: valueToString(row?.countryCode),
      portCity: valueToString(row?.city),
      portRecKey: valueToNull(row?.portRecKey),
      portState: valueToString(row?.portState),
      portType: valueToString(row?.portType),
      portZip: valueToString(row?.portZip),
      stopSequence: valueToNumber(row?.sequence),
      stopTypeId: valueToString(row?.stopType),
    })),
    transportationGroup: valueToString(data?.transportationGroup),
    transportationMode: valueToString(data?.transportationMode),
    urgency: valueToString(data?.urgency),
  };
};
